
import cepPromise from "cep-promise";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../components/Checkbox/Checkbox";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import { useAuth } from "../../../contexts/auth";
import ClientLicenceService from "../../../services/ClientLicenceService";
import CondominioService from "../../../services/CondominioService";
import "./FormCondominios.css";
import { useUserStore } from "../../../contexts/userStore";
import Select from "../../../components/Select/Select";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import ResponsibleList from "../../../components/ResponsibleList/ResponsibleList";
import Button from "../../../components/Button/Button";
import ResponsibleModal from "../../Clientes/FormClients/ResponsibleModal";
import TagList from "../../../components/TagList/TagList";
import { TagSelector } from "../../../components/TagSelector/TagSelector";
import { toCamelCase } from "../../../utils/string";
import { TagFieldInput } from "../../../components/TagFieldInput/TagFieldInput";
import { isDiff } from "../../../utils/array";
import { LicenseSelect } from "../../../components/LicenseSelect/LicenseSelect";
import { UnitSelector } from "../../../components/UnitSelector/UnitSelector";
import { TbBuildingCommunity } from "react-icons/tb";
import ImagesService from "../../../services/ImagesService";
import { VscTypeHierarchy, VscTypeHierarchySub } from "react-icons/vsc";
import UploadButton from "../../../components/UploadButton/UploadButton";
import { Buffer } from "buffer";
import { NotificationManager } from "react-notifications";
import { TagSingleSelector } from "../../../components/TagSingleSelector/TagSingleSelector";
import { TagType } from "../../../enums/tagTypes";
import { wait } from "../../../utils/timer";
import LicenseService from "../../../services/LicensesService";

function FormCondominios(props) {
	const { user } = useAuth();
	const { condominiums, selectedCondominio } = useUserStore();
	const [nomeLocal, setNomeLocal] = useState(props.condominio?.name);
	const [addressId, setAddressId] = useState(props.condominio?.address?.id);
	const [bairro, setBairro] = useState(props.condominio?.address?.district);
	const [rua, setRua] = useState(props.condominio?.address?.streetName);
	const [numero, setNumero] = useState(props.condominio?.address?.streetNumber);
	const [complemento, setComplemento] = useState(props.condominio?.address?.complement);
	const [cidade, setCidade] = useState(props.condominio?.address?.city);
	const [uf, setUf] = useState(props.condominio?.address?.state);
	const [pais, setPais] = useState(props.condominio?.address?.country);
	const [parentId, setParentId] = useState(props.condominio?.parentId);
	const [parent, setParent] = useState(null);
	const [informUserOnEnter, setInformUserOnEnter] = useState(
		props.condominio?.informUserOnEnter
	);
	const [licencas, setLicencas] = useState([]);
	const [licencasExcluidas, setLicencasExcluidas] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	const [cep, setCep] = useState("");
	const [hasEquipment, setHasEquipment] = useState(false);
	const [materiality, setMateriality] = useState(props.condominio?.materiality ?? 1);

	const [isActiveCpfConstraint, setIsActiveCpfConstraint] = useState(false);
	const [isActiveRgConstraint, setIsActiveRgConstraint] = useState(false);
	const [isActiveEmailConstraint, setIsActiveEmailConstraint] = useState(false);
	const [isActivePhoneConstraint, setIsActivePhoneConstraint] = useState(false);

	const [facialReadersMode, setFacialReadersMode] = useState(1);

	const [responsibles, setResponsibles] = useState([]);
	const [showRespModal, setShowRespModal] = useState(false);
	const [useParentAddress, setUseParentAddress] = useState(props.condominio?.useParentAddress ?? false);

	const [originalTags, setOriginalTags] = useState(null);
	const [tags, setTags] = useState([]);
	const [metadata, setMetadata] = useState([]);
	const [showTagModal, setShowTagModal] = useState(false);
	const [hideMateriality, setHideMateriality] = useState(false);
	const [hideParentAddress, setHideParentAddress] = useState(false);

	const [externalId, setExternalId] = useState(props.condominio?.externalId);
	const [isSuborganization, setIsSuborganization] = useState(props.condominio?.isSubOrganization ?? false);
	const [document, setDocument] = useState(props.condominio?.document);
	const [site, setSite] = useState(props.condominio?.site);
	const [primaryColor, setPrimaryColor] = useState(props.condominio?.primaryColor);
	const [secondaryColor, setSecondaryColor] = useState(props.condominio?.secondaryColor);
	const [urlLogo, setUrlLogo] = useState(props.condominio?.urlLogo);
	const [photoFile, setPhotoFile] = useState();
	const [currentPhotoFile, setCurrentPhotoFile] = useState();
	const [isSubmitting, setIsSubmitting] = useState(false);

	async function loadCurrentPhotoFile() {
		if (!props.condominio?.urlLogo) return;
		const response = await ImagesService.getImage(props.condominio?.urlLogo);
		if (!response.data) return;
		const responseImage = await ImagesService.getRawImage(response.data.replace("[:STORAGE_ADDRESS:]", window.location.hostname));
		const binaryData = responseImage.data;
		const base64Data = new Buffer.from(binaryData, "binary").toString(
			"base64",
		);
		const originalDataUrl = `data:image/png;base64,${base64Data}`;
		setCurrentPhotoFile(originalDataUrl);
	}

	useEffect(() => {
		if (parentId && condominiums) {
			setParent(condominiums.find(unit => Number(unit.id) === Number(parentId)));
		}
	}, [parentId, condominiums]);

	async function getResponsibles() {
		const response = await CondominioService.listResponsibles(props.condominio.id);
		if (response.data) {
			setResponsibles(response.data?.responsibles || []);
		}
	}

	useEffect(() => {
		setNomeLocal(props.condominio?.name);
		setBairro(props.condominio?.address?.district);
		setRua(props.condominio?.address?.streetName);
		setAddressId(props.condominio?.address?.id);
		setNumero(props.condominio?.address?.streetNumber);
		setComplemento(props.condominio?.address?.complement);
		setCidade(props.condominio?.address?.city);
		setUf(props.condominio?.address?.state);
		setPais(props.condominio?.address?.country);
		setInformUserOnEnter(props.condominio?.informUserOnEnter);
		setShowLoader(false);
		setCep(props.condominio?.address?.postalCode || "");
		setParentId(props.condominio?.parentId ?? `${props.parentUnitId ?? selectedCondominio}`);
		setUseParentAddress(props.condominio?.useParentAddress ?? false);
		setIsActiveCpfConstraint(props.condominio?.isActiveCpfConstraint);
		setIsActiveRgConstraint(props.condominio?.isActiveRgConstraint);
		setIsActiveEmailConstraint(props.condominio?.isActiveEmailConstraint);
		setIsActivePhoneConstraint(props.condominio?.isActivePhoneConstraint);
		setFacialReadersMode(Number(props.condominio?.facialReadersMode || 1));
		setMetadata(props.condominio?.metadata ?? []);
		setOriginalTags(props.condominio?.tags ?? []);
		setTags(props.condominio?.tags ?? []);
		setMateriality(props.condominio?.materiality ?? 1);
		if (props.condominio?.licenses && props.condominio.licenses.length > 0) {
			setHasEquipment(true);
			setLicencas(props.condominio.licenses.map(l => l.id));
		}
		if (props.condominio?.id) {
			getResponsibles(props.condominio.id);
		}
		setExternalId(props.condominio?.externalId);
		setIsSuborganization(props.condominio?.isSubOrganization ?? false);
		setDocument(props.condominio?.document);
		setSite(props.condominio?.site);
		setPrimaryColor(props.condominio?.primaryColor);
		setSecondaryColor(props.condominio?.secondaryColor);
		setUrlLogo(props.condominio?.urlLogo);
		if (props.condominio?.urlLogo) {
			loadCurrentPhotoFile();
		}
	}, [props.condominio]);

	const navigate = useNavigate();

	const buildPayload = (urlFromResponse = null) => {
		let payload = {
			id_client: Number(user.userData.selectedOrganizationId),
			address_id: addressId || null,
			cep: cep,
			district: bairro,
			street_name: rua,
			street_number: numero,
			complement: complemento,
			city: cidade,
			uf: uf,
			country: pais,
			name_local: nomeLocal,
			materiality: materiality,
			inform_user_on_enter: informUserOnEnter,
			is_device_unit: false,
			parent_unit_id: parentId || null,
			use_parent_address: useParentAddress || false,
			is_active_cpf_constraint: isActiveCpfConstraint,
			is_active_rg_constraint: isActiveRgConstraint,
			is_active_email_constraint: isActiveEmailConstraint,
			is_active_phone_constraint: isActivePhoneConstraint,
			facial_readers_mode: Number(facialReadersMode || 1),
			responsibles,
			metadata,
			tags: tags?.map(t => t.externalId),
			external_id: externalId,
			is_suborganization: isSuborganization,
			document: document,
			site: site,
			primary_color: primaryColor,
			secondary_color: secondaryColor,
			url_logo: urlFromResponse ?? urlLogo,
			hasEquipment,
		};
		return payload;
	};

	async function handlePhotoSubmission(externalId) {
		let newUrl = null;
		if (photoFile) {
			const formData = new FormData();
			formData.append("file", photoFile);
			formData.append("entity", "unit");
			formData.append("organizationExternalId", user.userData.selectedOrganization.externalId);
			formData.append("unitExternalId", externalId);
			const response = await ImagesService.storeImage(formData);
			return response.data.payload.id;
		}
		return newUrl;
	}

	async function handleSubmit(event) {
		event.preventDefault();
		if (!parentId) {
			NotificationManager.error("", "Obrigatório a seleção da unidade parente", 5000);
			return;
		}
		if (props.type === "edicao") {
			setIsSubmitting(true);
			await handleEdit(event);
			setIsSubmitting(false);
			return;
		}
		setIsSubmitting(true);
		try {
			const payload = buildPayload();
			const response = await CondominioService.createCondominio(payload);
			if (response.data.id) {
				await handleEdit(event, response.data.id, response.data.externalId);
			}
		} catch { }
		setIsSubmitting(false);
	}

	async function handleEdit(event, id = null, externalId = null) {
		event.preventDefault();
		const urlFromResponse = await handlePhotoSubmission(externalId ?? props.condominio.externalId);
		const payload = buildPayload(urlFromResponse);
		const response = await CondominioService.updateCondominio(
			id ?? props.condominio.id,
			payload
		);
		if (response.data.id) {
			navigate("../consulta-condominios", {
				state: { refresh: true }
			});
			updateCondominiumLicences(id ?? props.condominio.id);
		}
	}

	async function handleDelete() {
		if (!props.condominio) return;
		await CondominioService.deleteCondominio(props.condominio.id);
		navigate("../consulta-condominios", {
			state: { deletedId: props.condominio.id },
		});
	}

	async function updateCondominiumLicences(idCondominium) {
		const licenseId = licencas?.filter(l => !isNaN(l) && l > 0)?.[0];
		if (licenseId) {
			await LicenseService.updateAllocation(Number(licenseId), idCondominium);
		}
	}

	const handleClickEditButton = () => {
		if (!props.condominio) return;
		navigate(`/condominios/${props.condominio.externalId}`, { state: props.condominio });
	};

	useEffect(() => {
		setHasEquipment(prevHasEquipment => prevHasEquipment || licencas.length > 0);
	}, [licencas])

	const handleCepBlur = (cepValue) => {
		const digits = cepValue.replace(/\D/g, "");
		if (cepValue && digits.length === 8) {
			cepPromise(cepValue)
				.then((result) => {
					setBairro(result.neighborhood || "");
					setRua(result.street || "");
					setCidade(result.city || "");
					setUf(result.state || "");
					setPais("Brasil");
				})
				.catch((error) => {
					console.error("CEP inválido ou não encontrado:", error);
				});
		}
	};

	function handleAddResponsible(resp) {
		if (responsibles.find(responsible => responsible.externalId === resp.externalId || responsible.email === resp.email || responsible.phone === resp.phone)) {
			return;
		}
		setResponsibles([...responsibles, resp]);
	}

	function handleRemoveResponsible(index) {
		const newList = [...responsibles];
		newList.splice(index, 1);
		setResponsibles(newList);
	}

	function handleRemoveTag(index) {
		const newList = [...tags];
		newList.splice(index, 1);
		onTagsChange(newList);
	}

	function onTagsChange(updatedTags) {
		const prevTagsIds = tags.map(t => t.externalId);
		const tagsIds = updatedTags.map(t => t.externalId);
		if (isDiff(prevTagsIds, tagsIds)) {
			setTags(updatedTags);
			const useDefaultsTag = updatedTags.find(t =>
				t.metadata &&
				t.metadata.__useDefaultValues__ === true &&
				Object.keys(t.metadata.__defaultValues__ ?? {}).length > 0
			);
			if (useDefaultsTag) {
				const forceDefaults = useDefaultsTag.metadata.__forceDefaultValues__ || false;
				const _materiality = useDefaultsTag.metadata.__defaultValues__.materiality;
				const _parentAddress = useDefaultsTag.metadata.__defaultValues__.parentAddress;
				setMateriality(_materiality);
				setUseParentAddress(_parentAddress);
				setHideParentAddress(_parentAddress && forceDefaults);
				setHideMateriality(_materiality && forceDefaults);
			} else {
				setHideParentAddress(false);
				setHideMateriality(false);
			}
		}
	}

	function mountTagFields() {
		let fields = [];
		for (const tag of tags.filter(tag => tag)) {
			if (tag.schema && tag.schema.length > 0) {
				fields = [
					...fields,
					...tag.schema,
				];
			}
		}

		if (!fields || fields.length === 0) {
			return null;
		}

		return (
			<div className="grid-2">
				{fields.map(field => (
					<div className={`${fields.length > 1 ? 'col-span-1' : 'col-span-2'}`}>
						<TagFieldInput
							key={field.id ?? toCamelCase(field.name)}
							fieldConfig={field}
							value={metadata?.find(mItem => mItem.name === toCamelCase(field.name))?.value ?? field.defaultValue}
							onChange={(newValue) => setMetadata(prevMeta => {
								const newMeta = [...prevMeta];
								const fieldIdx = newMeta.findIndex(mItem => mItem.name === toCamelCase(field.name));

								if (fieldIdx === -1) {
									newMeta.push({ name: toCamelCase(field.name), value: newValue });
								} else {
									newMeta[fieldIdx] = { name: toCamelCase(field.name), value: newValue };
								}

								return newMeta;
							})}
						/>
					</div>
				))}
			</div>
		);
	}

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				tituloConsulta={props.condominio?.name_local || null}
				tituloCadastro="Cadastro de Unidade Organizacional"
				text={`
					Uma unidade organizacional é um objeto genérico que é caracterizado pelas etiquetas, disposto dentro de sua hierarquia organizacional. 
					Pode representar qualquer recurso, seja uma sub-empresa, apartamento, bloco, área ou departamento. 
					As licenças de dispositivos devem ser alocadas em uma unidade organizacional.
				`}
				icon={<TbBuildingCommunity size={20} />}
				backRoute={"/consulta-condominios"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<div className="w-full flex flex-col justify-start gap-2!">
					<div className="w-full">
						<Form
							handleSubmit={handleSubmit}
							type={props.type}
							handleClickEdit={handleClickEditButton}
							handleDelete={handleDelete}
							navigateCancelUrl="../consulta-condominios"
							askForPasswordOnDelete={true}
							className="form-condominio"
							isSubmitting={isSubmitting}
						>
							<p className="input-label">Tipo da unidade</p>
							<div className="tag-type-selector">
								<div>
									<input
										id="unit"
										type="radio"
										name="tag-type"
										disabled={props.type === "consulta" || isSubmitting}
										value={'unit'}
										onChange={e => setIsSuborganization(e.target.value === 'suborganization')}
										checked={!isSuborganization}
									/>
									<label htmlFor="unit" className="flex-row! items-center! w-fit! h-fit!">
										<VscTypeHierarchySub size={27} />
										Normal
									</label>
								</div>
								<div>
									<input
										id="suborganization"
										type="radio"
										name="tag-type"
										disabled={props.type === "consulta" || isSubmitting}
										value={'suborganization'}
										onChange={e => setIsSuborganization(e.target.value === 'suborganization')}
										checked={isSuborganization}
									/>
									<label htmlFor="suborganization" className="flex-row! items-center! w-fit! h-fit!">
										<VscTypeHierarchy size={27} />
										Sub-Organização
									</label>
								</div>
							</div>
							{isSuborganization ? (
								<div className={`container-image-info-name mb-3! ${props.type === 'consulta' ? 'container-unit-consulta' : ''}`}>
									<UploadButton
										onFileChanged={(file) => setPhotoFile(file)}
										label="Importar Logo"
										disabled={props.type === "consulta" || isSubmitting}
										currentFileBase64={currentPhotoFile}
									/>
									<div className="container-info-client">
										<div className="container-name-cpf">
											<div className={`w-full ${props.type === 'consulta' ? 'flex flex-col gap-2!' : 'grid-3'}`}>
												<Input
													name="name_local"
													id="name_local"
													labelText="Nome *"
													value={nomeLocal}
													onChange={({ target }) => setNomeLocal(target.value)}
													disabled={props.type === "consulta" || isSubmitting}
													required={true}
													tooltipText="Nome do condomínio ou local"
													tooltipVisible={true}
												/>
												<UnitSelector
													type={props.type}
													unitId={props.condominio?.id}
													parentId={parentId}
													setParentId={setParentId}
													disabled={props.type !== "cadastro" || isSubmitting}
												/>
												<TagSingleSelector
													parentId={parentId}
													type={TagType.UNIT}
													selectedTag={tags[0]}
													onTagChange={_tag => {
														setTags([_tag]);
													}}
													filters={{ sendToDevices: false }}
													disabled={props.type === 'consulta' || isSubmitting}
												/>
											</div>
											<div className={`w-full ${props.type === 'consulta' ? 'flex flex-col gap-2!' : 'grid-2'}`}>
												<Input
													name="document"
													id="document"
													labelText="CPF/CNPJ"
													value={document}
													onChange={({ target }) => setDocument(target.value)}
													disabled={props.type === "consulta" || isSubmitting}
													minLength={"14"}
													maxLength={"18"}
													showCpfCnpjMask={document?.length >= 11}
													showCpfMask={document?.length <= 11}
												/>
												<Input
													name={"site"}
													id="site"
													labelText={"Site"}
													onChange={({ target }) => setSite(target.value)}
													value={site}
													hidden={props.type === "consulta"}
													disabled={props.type === "consulta" || isSubmitting}
												/>
											</div>
											<div className="grid-2">
												<Input
													name="primaryColor"
													id="primaryColor"
													type="color"
													labelText="Cor primária"
													value={primaryColor}
													onChange={({ target }) => setPrimaryColor(target.value)}
													disabled={props.type === "consulta" || isSubmitting}
													required={false}
												/>
												<Input
													name="secondaryColor"
													id="secondaryColor"
													type="color"
													labelText="Cor secundária"
													value={secondaryColor}
													onChange={({ target }) => setSecondaryColor(target.value)}
													disabled={props.type === "consulta" || isSubmitting}
													required={false}
												/>
											</div>
										</div>
									</div>
								</div>
							) : (
								<div className={`w-full ${props.type === 'consulta' ? 'flex flex-col gap-3' : 'grid-3'}`}>
									<Input
										name="name_local"
										id="name_local"
										labelText="Nome *"
										value={nomeLocal}
										onChange={({ target }) => setNomeLocal(target.value)}
										disabled={props.type === "consulta" || isSubmitting}
										required={true}
										tooltipText="Nome do condomínio ou local"
										tooltipVisible={true}
									/>
									<UnitSelector
										type={props.type}
										unitId={props.condominio?.id}
										parentId={parentId}
										setParentId={setParentId}
										disabled={props.type !== "cadastro" || isSubmitting}
									/>
									<TagSingleSelector
										parentId={parentId}
										type={TagType.UNIT}
										selectedTag={tags[0]}
										onTagChange={_tag => {
											setTags([_tag]);
										}}
										filters={{ sendToDevices: false }}
										disabled={props.type === 'consulta' || isSubmitting}
									/>
								</div>
							)}
							{props.type !== "consulta" && (
								<>
									<div className="grid-2">
										<div className="responsibles-container col-span-2" style={{ width: '100%' }}>
											<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
												<h4 className="input-label" style={{ marginBottom: 0 }}>Responsáveis</h4>
												<div className="container-buttons" style={{ width: '100%', flexDirection: 'row', justifyContent: 'end', marginTop: 0 }}>
													{props.type !== "consulta" && (
														<Button
															label="Adicionar"
															action="add"
															onClick={() => setShowRespModal(true)}
															className="button-link"
															disabled={isSubmitting}
														/>
													)}
												</div>
											</div>
											<ResponsibleList
												responsibles={responsibles}
												onRemove={handleRemoveResponsible}
												disabled={props.type === "consulta" || isSubmitting}
											/>
										</div>
									</div>
									{mountTagFields()}
								</>
							)}
							{!hideMateriality && (
								<>
									<h3 className="bordered muted-md mt-3! mb-0!">Localização</h3>

									<div className={`${(materiality === 1 && parent && parent.address && props.type !== 'consulta') ? 'grid-2' : 'w-full'}`}>
										<Select
											labelText="Materialidade"
											name="materiality"
											id="materiality"
											value={materiality}
											disabled={props.type === "consulta" || isSubmitting}
											onChange={({ target }) => {
												if (Number(target.value) === 2) {
													setUseParentAddress(false);
												}
												setMateriality(Number(target.value))
											}}
											required={true}
											options={[
												{ value: 1, text: "Unidade Física" },
												{ value: 2, text: "Unidade Lógica" },
											]}
										/>
										{!hideParentAddress && materiality === 1 && parent && parent.address && (
											<div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', paddingTop: 20 }}>
												<ToggleButton
													label={`Utilizar endereço do parente`}
													selected={useParentAddress}
													onClick={() => setUseParentAddress(!useParentAddress)}
													disabled={props.type === "consulta" || isSubmitting}
													tooltipVisible={true}
													tooltipText={
														"Essa unidade deve espelhar o endereço da unidade pai. Caso o endereço da unidade pai seja alterado, o endereço dessa unidade será atualizado automaticamente."
													}
												/>
											</div>
										)}
									</div>
								</>
							)}
							{materiality === 1 && !useParentAddress && (
								<>
									<div className="address-section mt-1! mb-0!">
										<Input
											name="cep"
											labelText="CEP *"
											value={cep}
											maxLength="9"
											onChange={(e) => {
												const val = e.target.value;
												setCep(val);
												if (val.replace(/\D/g, "").length === 8) {
													handleCepBlur(val);
												}
											}}
											required={true}
											disabled={props.type === "consulta" || isSubmitting}
											mask="CEP"
											tooltipText="CEP do local ou condomínio"
											tooltipVisible={true}
										/>
										<Input
											name="rua"
											id="rua"
											labelText="Rua *"
											value={rua}
											onChange={({ target }) => setRua(target.value)}
											required={true}
											disabled={props.type === "consulta" || isSubmitting}
										/>
										<Input
											name="bairro"
											id="bairro"
											labelText="Bairro *"
											value={bairro}
											onChange={({ target }) => setBairro(target.value)}
											required={true}
											disabled={props.type === "consulta" || isSubmitting}
										/>
										<Input
											name="numero"
											id="numero"
											labelText="Número *"
											value={numero}
											onChange={({ target }) => setNumero(target.value)}
											required={true}
											disabled={props.type === "consulta" || isSubmitting}
										/>
										<Input
											name="complemento"
											id="complemento"
											labelText="Complemento"
											value={complemento}
											onChange={({ target }) => setComplemento(target.value)}
											disabled={props.type === "consulta" || isSubmitting}
										/>
										<Input
											name="cidade"
											id="cidade"
											labelText="Cidade *"
											value={cidade}
											onChange={({ target }) => setCidade(target.value)}
											required={true}
											disabled={props.type === "consulta" || isSubmitting}
										/>
										<Input
											name="uf"
											id="uf"
											labelText="UF *"
											value={uf}
											onChange={({ target }) => setUf(target.value)}
											required={true}
											disabled={props.type === "consulta" || isSubmitting}
										/>
										<Input
											name="pais"
											id="pais"
											labelText="País *"
											value={pais}
											onChange={({ target }) => setPais(target.value)}
											required={true}
											disabled={props.type === "consulta" || isSubmitting}
										/>
									</div>
								</>
							)}
							{props.type !== "consulta" && (
								<div className="w-full my-3!">
									<h3 className="muted-md bordered mb-3! mt-1!">Configuração de licença</h3>

									<div style={{ display: 'flex', justifyContent: 'start', width: '100%' }}>
										<ToggleButton
											label={`Associar licença de dispositivo`}
											selected={hasEquipment}
											onClick={() => setHasEquipment(!hasEquipment)}
											disabled={props.type === "consulta" || isSubmitting}
											tooltipVisible={true}
											tooltipText={
												"Informa ao sistema se essa unidade organizacional possui uma licença vinculada."
											}
										/>
									</div>
									{hasEquipment && (
										<>
											<div className="flex flex-col gap-4! mt-3.5!">
												<div className="form-cond-dual-list-condominiums">
													<LicenseSelect
														selectedLicense={licencas[0] ? Number(licencas[0]) : null}
														setSelectedLicense={(licenseId) => {
															setLicencas(isNaN(licenseId) ? [] : [licenseId]);
														}}
														unitId={props.condominio?.id}
														type={props.type}
													/>
												</div>
												{licencas.filter(l => !isNaN(l) && l > 0).length > 0 && (
													<>
														<div className="grid-2">
															<Select
																labelText="Fotos dos usuários nos faciais"
																name="facial_readers_mode"
																id="facial_readers_mode"
																value={facialReadersMode}
																disabled={props.type === "consulta" || isSubmitting}
																onChange={({ target }) =>
																	setFacialReadersMode(target.value)
																}
																required={true}
																options={[
																	{ value: 1, text: "Automático (Por grupo de acesso)" },
																	{ value: 2, text: "Manual (Por usuário)" },
																]}
															/>
															<Checkbox
																labelText="Informar usuário ao entrar"
																defaultChecked={informUserOnEnter}
																onChange={({ target }) => setInformUserOnEnter(target.checked)}
																required={false}
																disabled={props.type === "consulta" || isSubmitting}
															/>
														</div>
														{props.type !== "consulta" && (
															<>
																<div className="user-contraints">
																	<h4 className="input-label mb-2!">Campos únicos (Usuários)</h4>
																	<div className="flex flex-col gap-2">
																		<ToggleButton
																			label={`${isActiveCpfConstraint
																				? "CPF único habilitado"
																				: "CPF único desabilitado"
																				}`}
																			selected={isActiveCpfConstraint}
																			onClick={() => setIsActiveCpfConstraint(!isActiveCpfConstraint)}
																			disabled={props.type === "consulta" || isSubmitting}
																			tooltipVisible={true}
																			tooltipText={
																				"Habilita ou desabilita a validação de cpf único para os usuários desse condomínio."
																			}
																		/>
																		<ToggleButton
																			label={`${isActiveRgConstraint
																				? "RG único habilitado"
																				: "RG único desabilitado"
																				}`}
																			selected={isActiveRgConstraint}
																			onClick={() => setIsActiveRgConstraint(!isActiveRgConstraint)}
																			disabled={props.type === "consulta" || isSubmitting}
																			tooltipVisible={true}
																			tooltipText={
																				"Habilita ou desabilita a validação de rg único para os usuários desse condomínio."
																			}
																		/>
																		<ToggleButton
																			label={`${isActiveEmailConstraint
																				? "Email único habilitado"
																				: "Email único desabilitado"
																				}`}
																			selected={isActiveEmailConstraint}
																			onClick={() => setIsActiveEmailConstraint(!isActiveEmailConstraint)}
																			disabled={props.type === "consulta" || isSubmitting}
																			tooltipVisible={true}
																			tooltipText={
																				"Habilita ou desabilita a validação de email único para os usuários desse condomínio."
																			}
																		/>
																		<ToggleButton
																			label={`${isActivePhoneConstraint
																				? "Telefone único habilitado"
																				: "Telefone único desabilitado"
																				}`}
																			selected={isActivePhoneConstraint}
																			onClick={() => setIsActivePhoneConstraint(!isActivePhoneConstraint)}
																			disabled={props.type === "consulta" || isSubmitting}
																			tooltipVisible={true}
																			tooltipText={
																				"Habilita ou desabilita a validação de telefone único para os usuários desse condomínio."
																			}
																		/>
																	</div>
																</div>
															</>
														)}
													</>
												)}
											</div>
										</>
									)}
								</div>
							)}
						</Form>
					</div>
				</div>
			)}
			<ResponsibleModal
				isOpen={showRespModal}
				onClose={() => setShowRespModal(false)}
				onAdd={handleAddResponsible}
			/>
			{originalTags !== null && (
				<TagSelector
					tags={tags}
					type={"UNIT"}
					isOpen={showTagModal}
					onLoad={(loadedTags) => {
						onTagsChange(loadedTags.filter(lTag => originalTags.find(oTag => oTag.externalId === lTag.externalId)));
					}}
					onClose={() => setShowTagModal(false)}
					onTagsChange={onTagsChange} />
			)}
		</React.Fragment>
	);
}

export default FormCondominios;
